import { createSlice } from "@reduxjs/toolkit";
import { snapshotForUser } from "./gamificationService";

const initialState = {
  userId: null,
  balance: 0,
  ledger: [],
  redemptions: [],
};

const gamificationSlice = createSlice({
  name: "gamification",
  initialState,
  reducers: {
    hydrateGamification: (state, action) => {
      const userId = action.payload;
      if (!userId) {
        state.userId = null;
        state.balance = 0;
        state.ledger = [];
        state.redemptions = [];
        return;
      }
      const snap = snapshotForUser(String(userId));
      state.userId = String(userId);
      state.balance = snap.balance;
      state.ledger = snap.ledger;
      state.redemptions = snap.redemptions;
    },
    setBalanceFromApi: (state, action) => {
      if (typeof action.payload === "number" && !Number.isNaN(action.payload)) {
        state.balance = action.payload;
      }
    },
    refreshGamification: (state) => {
      if (!state.userId) return;
      const snap = snapshotForUser(state.userId);
      state.balance = snap.balance;
      state.ledger = snap.ledger;
      state.redemptions = snap.redemptions;
    },
  },
});

export const { hydrateGamification, refreshGamification, setBalanceFromApi } =
  gamificationSlice.actions;
export default gamificationSlice.reducer;
